// external imports
import { Field, MutationType } from 'typegraph';

// internal imports
import { Status } from 'common/constants/Constants';
import { ID } from 'common/entities/IEntity';
import IService from 'core/service/IService';
import IEntity from 'core/util/IEntity';
import Class from "../../util/Class";
import { IManyResult } from "../query/IQueryService";


export interface IMutationResult<T> {
	operationPerformed: MutationType;
	operationResult: Status;
	entityId: number;
	entity?: T;
}

export default abstract class IMutationService implements IService {
	protected static DEFAULT_ID = "default";
	private static REGISTRY = "api:mutation";

	public getRegistry(): string {
		return IMutationService.REGISTRY;
	}

	public getActive(): string {
		return IMutationService.DEFAULT_ID;
	}

	public getConditions = () => undefined;

	public abstract save<T extends IEntity>(entity: T, entityClass?: Class<T>): Promise<IMutationResult<T>>;

	public abstract create<T extends IEntity>(entity: T, entityClass?: Class<T>): Promise<IMutationResult<T>>;

	public abstract update<T extends IEntity>(entity: T, entityClass?: Class<T>): Promise<IMutationResult<T>>;

	public abstract delete<T extends IEntity>(entity: T, entityClass?: Class<T>): Promise<IMutationResult<T>>;

	public abstract getServiceId(): string;

	protected static parseResponse<T>(promise: Promise<any>): Promise<IMutationResult<T>> {
		return promise.then((result) => {
			return {entity: result.data.entity};
		}) as any;
	}
}



// WEBPACK FOOTER //
// ./src/core/service/mutation/IMutationService.ts